<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative">
            <b-row>
                <b-col md="6">
                    <dropdown-projects
                        required
                        show-icon-required
                        @setDefaultValue="setDefaultProject"
                        v-model="info.project"
                        @change="resetDataByProject">
                    </dropdown-projects>
                </b-col>
            </b-row>
            <template v-if="$route.params.id != 0">
                <b-row class="my-3">
                    <b-col md="5">
                        <gofix-text-field class-label="width-120" label="Submitted Date" oneline>{{ Item.submitted_at ? $options.filters.formatDatebyMoment(Item.submitted_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                    </b-col>
                    <b-col md="7" v-if="Item.pm_acknowledged_at && ['PM Acknowledged', 'Completed'].includes(info.status)">
                        <gofix-text-field class-label="width-175" label="PM Acknowledged Date" oneline>{{ Item.pm_acknowledged_at ? $options.filters.formatDatebyMoment(Item.pm_acknowledged_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                    </b-col>
                    <b-col md="7" v-if="Item.acknowledged_at && ['Contractor Supervisor Acknowledged', 'Completed'].includes(info.status)">
                        <gofix-text-field class-label="width-312" label="Contractor Supervisor Acknowledged Date" oneline>{{ Item.acknowledged_at ? $options.filters.formatDatebyMoment(Item.acknowledged_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="5">
                        <gofix-text-field class-label="width-120" label="Submitted By" oneline>{{ Item.submitted_by && Item.submitted_by.name ? Item.submitted_by.name : '' }}</gofix-text-field>
                    </b-col>
                    <b-col md="7" v-if="Item.pm_acknowledged_by && ['PM Acknowledged', 'Completed'].includes(info.status)">
                        <gofix-text-field class-label="width-175" label="PM Acknowledged By" oneline>{{ Item.pm_acknowledged_by && Item.pm_acknowledged_by.name ? Item.pm_acknowledged_by.name : '' }}</gofix-text-field>
                    </b-col>
                    <b-col md="7" v-if="Item.acknowledged_by && ['Contractor Supervisor Acknowledged', 'Completed'].includes(info.status)">
                        <gofix-text-field class-label="width-312" label="Contractor Supervisor Acknowledged By" oneline>{{ Item.acknowledged_by && Item.acknowledged_by.name ? Item.acknowledged_by.name : '' }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row class="my-3" v-if="['Completed'].includes(info.status)">
                    <b-col md="12" class="mb-3">
                        <gofix-text-field class-label="width-120" label="Completed Date" oneline>{{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class-label="width-120" label="Completed By" oneline>{{ Item.completed_by && Item.completed_by.name ? Item.completed_by.name : '' }}</gofix-text-field>
                    </b-col>
                </b-row>
            </template>
        </gofix-card>
        <gofix-card title="STAGE 1: UNSAFE ACT / CONDITION* REPORT:" classHeader="mb-2" classContent="position-relative">
            <b-row>
                <b-col md="6">
                    <gofix-form-input 
                        label="Reported By" 
                        autocomplete="off"
                        required 
                        show-icon-required 
                        disabled
                        v-model="info.created_by_user.name">
                    </gofix-form-input>
                </b-col>
                <b-col md="6">
                    <gofix-form-dropdown 
                        vLabel="name"
                        label="Designation" 
                        :options="options.user_roles" 
                        :reduce="option => option.id"
                        v-model="info.role_id" >
                    </gofix-form-dropdown>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <dropdown-companies 
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        required
                        show-icon-required
                        v-model="info.supplier"
                        @change="resetContractorSupervisor">
                    </dropdown-companies>
                </b-col>
                <b-col md="6">
                    <b-row align-v="center">
                        <b-col md="6">
                            <gofix-form-input-date
                                label="Date"
                                popoverDirection="top"
                                required
                                show-icon-required
                                v-model="info.date" >
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time
                                label="Time"
                                popoverDirection="top"
                                required
                                show-icon-required
                                v-model="info.time" >
                            </gofix-form-input-time>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <dropdown-user-duties 
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        :company-id="info.supplier && info.supplier.id ? info.supplier.id : null"
                        required
                        show-icon-required
                        role-name="Contractor Supervisor"
                        v-model="info.contractor_supervisor_by">
                    </dropdown-user-duties>
                </b-col>
                <b-col md="6">
                    <dropdown-locations 
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        required
                        show-icon-required
                        v-model="info.equipment">
                    </dropdown-locations>
                </b-col>
            </b-row>
        </gofix-card>
        <template v-if="$route.params.id != 0">
            <gofix-card title="SUPPORTING DOCUMENT (IF APPLICABLE)" classHeader="mb-2" classContent="position-relative">
                <b-row class="my-3">
                    <b-col md="12">
                        <div class="d-flex align-items-center">
                            <span class="mr-3">Project File</span>
                            <div class="mr-3" v-if="info.supporting_documents_file && info.supporting_documents_file.length">
                                <b-list-group horizontal="md">
                                    <b-list-group-item class="mr-2" v-for="(item, index) in info.supporting_documents_file" :key="index">
                                        {{ item.image_file_name }}
                                        <span class="icon cursor-pointer mx-2" @click="removeProjectFile(item)" v-if="!$disabledCreateOrUpdate(info, $accessModule.non_conformance_report)">
                                            <svg width="12" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.3 0.99404C13.1131 0.797476 12.8595 0.687011 12.595 0.687011C12.3305 0.687011 12.0768 0.797476 11.89 0.99404L6.99997 6.11669L2.10997 0.983543C1.92314 0.786979 1.66949 0.676514 1.40497 0.676514C1.14045 0.676514 0.886802 0.786979 0.699971 0.983543C0.309971 1.39293 0.309971 2.05426 0.699971 2.46365L5.58997 7.5968L0.699971 12.73C0.309971 13.1393 0.309971 13.8007 0.699971 14.2101C1.08997 14.6195 1.71997 14.6195 2.10997 14.2101L6.99997 9.07691L11.89 14.2101C12.28 14.6195 12.91 14.6195 13.3 14.2101C13.69 13.8007 13.69 13.1393 13.3 12.73L8.40997 7.5968L13.3 2.46365C13.68 2.06476 13.68 1.39294 13.3 0.99404Z" fill="black" fill-opacity="0.6" />
                                            </svg>
                                        </span>
                                    </b-list-group-item>
                                </b-list-group>
                            </div>
                            <gofix-button class="mr-2" label="Download" @click="dowloadAttachments" outline>
                                <template  slot="gofix:button:beforeLabel">
                                    <i class="icon-cloud-download icons font-xl mr-2"></i>
                                </template>
                            </gofix-button>
                            <div class="upload-btn-wrapper ml-0 mt-0 d-block">
                                <b-form-file id="fileInputMulti" v-model="attachment.project_file" :plain="true"></b-form-file>
                                    <gofix-button class="icon-svg icon-svg-left mb-0" label="Upload" outline v-if="!$disabledCreateOrUpdate(info, $accessModule.non_conformance_report)">
                                    <template slot="gofix:button:beforeLabel">
                                        <i class="icon-cloud-upload icons font-xl mr-2"></i>
                                    </template>
                                </gofix-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <template v-for="(item, index) in info.supporting_documents">
                    <b-row :key="index">
                        <b-col md="4">
                            <div class="d-flex align-items-center">
                                <b-form-checkbox v-model="item.is_checked" class="mx-3" @input="resetValueSupportingDocument(index)"></b-form-checkbox>
                                <gofix-form-input :disabled="!item.is_checked" :label="item.doc_type == 'Risk Assessment' ? 'Risk Assessment(RA)' : item.doc_type" v-model="item.input_value"></gofix-form-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <gofix-form-input v-if="item.doc_type == 'Risk Assessment'" :disabled="!item.is_checked" label="RA Ref" v-model="item.ra_ref"></gofix-form-input>
                            <gofix-form-input v-else label="Item No." :disabled="!item.is_checked" v-model="item.item_no"></gofix-form-input>
                        </b-col>
                        <b-col md="4">
                            <gofix-form-input v-if="item.doc_type == 'Risk Assessment'" :disabled="!item.is_checked" label="Item No." v-model="item.item_no"></gofix-form-input>
                            <gofix-form-input v-else label="Photo" :disabled="!item.is_checked" v-model="item.photo"></gofix-form-input>
                        </b-col>
                    </b-row>
                </template>
            </gofix-card>
            <gofix-card title="STAGE 2: FOLLOW-UP ACTION (TICK WHERE NECESSARY):" classHeader="mb-2" classContent="position-relative">
                <b-row align-v="center" class="mt-3">
                    <b-col v-for="(it, idx) in checklist" md="12" class="mb-3" :key="idx">
                        <b-form-checkbox :value="true" :unchecked-value="false" v-model="it.input.value" class="custom-checkbox-safety" @input="inputValue(it)">
                            {{ it.name }}
                        </b-form-checkbox>
                        <template v-if="it.expand">
                            <b-row v-if="it.input.value && (typeof it.expand === 'object' && it.expand.ref_no)">
                                <b-col md="4">
                                    <gofix-form-input class="mb-0" :label="it.expand.ref_no.name" v-model="it.expand.ref_no.value" @input="inputValue(it)"></gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row v-if="Array.isArray(it.expand) && it.expand && it.expand.length">
                                <b-col md="12" v-for="(item_ex, idx_ex) in it.expand" :key="idx_ex" class="mt-2">
                                    <b-row class="m-0">
                                        <b-col :md="idx_ex > 0 ? 2 : 12">
                                            <gofix-form-input-number
                                                v-if="item_ex.administrative_charge"
                                                label=" "
                                                :class="{'max-width-270': idx_ex == 0}"
                                                :disabled="!it.input.value"
                                                v-model="item_ex.administrative_charge.value"
                                                prefix="$"
                                                @focus="handleFocus(arguments[0], it)"
                                                @change="inputValue(it)"/>
                                        </b-col>
                                        <template v-if="it.input.value">
                                            <b-col :md="idx_ex > 0 ? 2 : 4">
                                                <template v-if="item_ex.contractor">
                                                    <!-- 
                                                        :reduce="option => option.id" -->
                                                    <gofix-form-dropdown
                                                        v-if="idx_ex == 0 || (idx_ex > 0 && item_ex.contractor.worker_id !== null)"
                                                        :label="item_ex.contractor.name"
                                                        vLabel="ic_fin"
                                                        class="mb-0"
                                                        @search="searchWorker"
                                                        :filterable="false"
                                                        v-model="item_ex.contractor.value"
                                                        @input="(val) => hanldeInputWorker(val, idx_ex, it)"
                                                        :options="options.workers">
                                                        <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                                            {{option.ic_fin}} - {{option.name}}
                                                        </template>
                                                        <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                                            {{option.ic_fin}} - {{option.name}}
                                                        </template>
                                                    </gofix-form-dropdown>
                                                    <gofix-form-input 
                                                        v-if="idx_ex > 0 && item_ex.contractor.worker_id === null"
                                                        :label="item_ex.contractor.name"
                                                        v-model="item_ex.contractor.value"
                                                        @input="inputValue(it)">
                                                    </gofix-form-input>
                                                </template>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input 
                                                    v-if="item_ex.id_wp"
                                                    :disabled="idx_ex == 0 || (idx_ex > 0 && item_ex.contractor.worker_id !== null)"
                                                    :label="item_ex.id_wp.name"
                                                    v-model="item_ex.id_wp.value"
                                                    @input="inputValue(it)">
                                                </gofix-form-input>
                                            </b-col>
                                            <b-col md="4" class="d-flex">
                                                <gofix-form-input 
                                                    :disabled="idx_ex == 0 || (idx_ex > 0 && item_ex.contractor.worker_id !== null)"
                                                    :label="item_ex.company.name"
                                                    v-model="item_ex.company.value"
                                                    @input="inputValue(it)">
                                                </gofix-form-input>
                                                <b-button v-if="idx_ex > 0" @click="handleDeleteExpand(it, idx_ex)" class="bg-transparent border-none ml-3" style="font-size: 20px;" title="Delete" v-b-tooltip.hover><i class="fa fa-trash-o"></i></b-button>
                                            </b-col>
                                        </template>
                                    </b-row>
                                </b-col>
                                <b-col md="12" v-if="it.input.value && it.expand[0].administrative_charge" class="mt-2">
                                    <gofix-button class="ml-3 mr-3" label="Add Worker(Available in the system)" @click="handleAddExpand(it.expand, false)" outline></gofix-button>
                                    <gofix-button label="Add Worker(Manual)" @click="handleAddExpand(it.expand, true)" outline></gofix-button>
                                </b-col>
                            </b-row>
                        </template>
                    </b-col>
                </b-row>
            </gofix-card>
            <gofix-card title="Description of Unsafe Act / Unsafe Condition" classHeader="mb-2" classContent="position-relative">
                <b-row align-v="center" class="mt-3">
                    <b-col md="12">
                        <p class="mb-2">(Attach Photograph / Drawings. Max photos: 4)</p>
                        <div>
                            <div v-if="info.photos && info.photos.length" class="photosThumb photosThumb-safety mt-0 mb-0">
                                <viewer-image :images="info.photos">
                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                        <ul class="list-thumb">
                                            <template v-for="(item, key) in info.photos">
                                                <li :key="key">
                                                    <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                    <span class="delete" @click.stop="deleteFile(item)" v-if="!$disabledCreateOrUpdate(info, $accessModule.non_conformance_report)">
                                                        <img src="img/close.png" alt />
                                                    </span>
                                                </li>
                                            </template>
                                        </ul>
                                    </template>
                                </viewer-image>
                            </div>
                            <div class="upload-btn-wrapper ml-0 mt-0 d-block" v-if="!$disabledCreateOrUpdate(this.info, $accessModule.non_conformance_report)">
                                <b-form-file id="fileInputMulti" v-model="attachment.files" :plain="true" :multiple="true"></b-form-file>
                                <gofix-button class="icon-svg icon-svg-left mb-2" label="Upload" outline>
                                    <template slot="gofix:button:beforeLabel">
                                        <span class="icon mr-2">
                                            <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                                <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                            </svg>
                                        </span>
                                    </template>
                                </gofix-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </gofix-card>
        </template>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Actions" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :disabled="jobOptionStatus.length == 0"
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                    <dropdown-user-duties 
                        v-if="Item.status == 'New'"
                        label="Submitted By"
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        :reduce="option => option.user_id"
                        :safetyOnlyFM="true"
                        role-name="Safety Officer"
                        v-model="modals.bacsicInfo.data.submitted_by_id">
                    </dropdown-user-duties>
                    <template v-if="Item.status == 'Submitted'">
                        <dropdown-user-duties 
                            v-if="['PM Acknowledged', 'Contractor Supervisor Acknowledged'].includes(modals.bacsicInfo.data.status)"
                            :label="`${modals.bacsicInfo.data.status} By`"
                            :project-id="info.project && info.project.id ? info.project.id : null"
                            :company-id="modals.bacsicInfo.data.status == 'Contractor Supervisor Acknowledged' && info.supplier && info.supplier.id ? info.supplier.id : null"
                            :reduce="option => option.user_id"
                            :safetyOnlyFM="modals.bacsicInfo.data.status == 'PM Acknowledged' ? true : false"
                            :role-name="modals.bacsicInfo.data.status == 'Contractor Supervisor Acknowledged' ? 'Contractor Supervisor' : 'Project Manager'"
                            v-model="modals.bacsicInfo.data.pm_acknowledged_by_id">
                        </dropdown-user-duties>
                    </template>
                    
                    <!-- <gofix-form-dropdown 
                        v-if="modals.bacsicInfo.data.status == 'Completed'"
                        label="Completed By" 
                        vLabel="name" 
                        @search="searchUsers" 
                        :filterable="false" 
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.completed_by_id" 
                        :options="modals.bacsicInfo.options.fm_users">
                        <template slot="gofixInput:dropdown:option"  slot-scope="option">
                            {{option.user_name}} - {{option.user_email}}
                        </template>
                        <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                            {{option.user_name}} - {{option.user_email}}
                        </template>
                    </gofix-form-dropdown> -->
                    <b-row v-if="Item.status == 'New'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.submitted_at" label="Submitted Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time internalKey="SubmittedTime" label="Submitted Time" v-model="modals.bacsicInfo.data.submitted_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="Item.status == 'Submitted' && modals.bacsicInfo.data.status == 'Contractor Supervisor Acknowledged'">
                        <b-col md="12">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.acknowledged_at" label="Contractor Supervisor Acknowledged Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-time internalKey="AcknowledgedTime" label="Contractor Supervisor Acknowledged Time" v-model="modals.bacsicInfo.data.acknowledged_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="Item.status == 'Submitted' && modals.bacsicInfo.data.status == 'PM Acknowledged'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.pm_acknowledged_at" label="PM Acknowledged Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time internalKey="PMAcknowledgedTime" label="PM Acknowledged Time" v-model="modals.bacsicInfo.data.pm_acknowledged_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="['Contractor Supervisor Acknowledged', 'PM Acknowledged'].includes(Item.status) && modals.bacsicInfo.data.status == 'Completed'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.completed_at" label="Completed Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Completed Time" v-model="modals.bacsicInfo.data.completed_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="checkShowPopUpSignature" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import { filters } from '@/_filterVar.js'
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    import DropdownProjects from '../elements/DropdownProjects.vue'
    import DropdownLocations from '../elements/DropdownLocations.vue'
    import DropdownCompanies from '../elements/DropdownCompanies.vue'
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    export default {
        name: 'non-conformance-report-detail',
        components: {
            ViewerImage,
            DropdownProjects,
            DropdownLocations,
            DropdownCompanies,
            DropdownUserDuties
        },
        data() {
            return {
                options: {
                    client_contracts: [],
                    scontracts: [],
                    equipments: [],
                    contractor_supervisors: [],
                    user_roles: [],
                    checklist_templates: [],
                    workers: [],
                    companies: []
                },
                timer: {
                    client_contracts: null,
                    scontracts: null,
                    equipments: null,
                    workers: null,
                },
                pagesEquipment: {
                    isCMS: '1',
                    limit: 100,
                    page: 1,
                    totalPage: 0,
                    filter: JSON.parse(JSON.stringify(filters['equipment']))
                },
                checklistItems: [],
                checkListEntryUpdate: [],
                info: {
                    id: null,
                    project: null,
                    contract: null,
                    status: null,
                    created_by_user: {
                        id: null,
                        name: null,
                        role_name: null
                    },
                    supplier: null,
                    date: null,
                    time: null,
                    equipment: null,
                    contractor_supervisor_by: null,
                    role_id: null,
                    supporting_documents_file: [],
                    photos: [],
                    checklist_template_id: null,
                    supporting_documents: [],
                    follow_up_actions: []
                },
                attachment: {
                    items: [],
                    files: [],
                    project_file: null,
                    project_file_push: null
                },
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            completed_by_id: null,
                            acknowledged_by_id: null,
                            pm_acknowledged_by_id: null,
                            submitted_by_id: null,
                            submitted_at: null,
                            submitted_at_hour: null,
                            acknowledged_at: null,
                            acknowledged_at_hour: null,
                            pm_acknowledged_at: null,
                            pm_acknowledged_at_hour: null,
                            completed_at: null,
                            completed_at_hour: null,
                        },
                        options: {
                            fm_users: [],
                            supllier_users: [],
                        }
                    }
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Contractor Supervisor Acknowledged', 'PM Acknowledged'],
                    'Contractor Supervisor Acknowledged': ['Completed'],                  
                    'PM Acknowledged': ['Completed'],                  
                }
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            jobOptionStatus() {
                if(this.option_status[this.Item.status]) return this.option_status[this.Item.status];
                return [];
            },
            checklist: function() {
                if(this.checklistItems && this.checklistItems.length) {
                    let checklist = [];
                    this.checklistItems.forEach((item) => {
                        item.safety_checklist_entries.forEach((it) => {
                            if(it.expand && Array.isArray(it.expand) && it.expand.length) {
                                it.expand.forEach((expand_item, key) => {
                                    if(key == 0) {
                                        if(expand_item.company && expand_item.company.company_id == "" && this.info.supplier && this.info.supplier.id) {
                                            expand_item.company.company_id = this.info.supplier.id
                                            expand_item.company.value = this.info.supplier.name
                                        }
                                    }
                                    if(expand_item.contractor && expand_item.contractor.worker_id && typeof expand_item.contractor.value !== 'object') {
                                        expand_item.contractor.value = {
                                            id: expand_item.contractor.worker_id,
                                            name: expand_item.contractor.value,
                                            ic_fin: expand_item.id_wp.value
                                        }
                                    }
                                    if(item.administrative_charge && item.administrative_charge.value) {
                                        item.administrative_charge.value = this.$accounting.formatMoney(item.administrative_charge.value)
                                    }
                                })
                            }
                            checklist.push(it);
                        });
                    });
                    return checklist;
                }
                return [];
            },
        },
        watch: {
            User: function() {
                this.setDefaultValue();
            },
            Item: function(val) {
                if(val && val.id)
                    this.setValue()
            },
            "attachment.files": function(val, old) {
                if (val) {
                    if(val.length > 4 || ((val.length + this.attachment.items.length) > 4)) {
                        return this.$alertNotification("Max photos: 4", "danger");
                    }

                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            }
                        };
                        this.attachment.items.push(file);
                        this.info.photos.push(data);
                    });
                }
                
            },
            "attachment.project_file": function (val) {
                if (val) {
                    let extensionAccept = ['csv', 'xls', 'xlsx', 'docx', 'doc', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if (!extensionAccept.includes(extension)) {
                        this.attachment.project_file = null
                        return  this.$alertNotification('File format is incorrect. Please select a .csv, .xls, .xlsx, .docx, .doc, .pdf, .txt, .jpeg, .jpg, .png, .gif file!', 'warning')
                    }

                    val.moment = moment().valueOf();
                    let data = {
                        moment: moment().valueOf(),
                        url: {
                            original: URL.createObjectURL(val),
                            medium: URL.createObjectURL(val),
                            thumb: URL.createObjectURL(val),
                        },
                        image_file_name: val.name
                    };

                    this.attachment.project_file_push = val
                    if(this.info.supporting_documents_file.length) {
                        this.info.supporting_documents_file[0] = data
                    } else {
                        this.info.supporting_documents_file.push(data)
                    }
                }
            },
            ClientContractID: function (val) {
                if (this.$route.params.id == "0") {
                    this.info.contract = (val && val.hasOwnProperty('id')) ? val : null;
                }
            },
            "modals.bacsicInfo.data.status": function() {
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    completed_by_id: null,
                    acknowledged_by_id: null,
                    pm_acknowledged_by_id: null,
                    submitted_by_id: null,
                    submitted_at: null,
                    submitted_at_hour: null,
                    acknowledged_at: null,
                    acknowledged_at_hour: null,
                    pm_acknowledged_at: null,
                    pm_acknowledged_at_hour: null,
                    completed_at: null,
                    completed_at_hour: null,
                })
            },
            "info.supplier": function() {
                this.getWorkers()
            }
        },
        created() {
            if (this.$route.params.id == "0") {
                this.setDefaultValue();
            } else {
                if(this.Item && this.Item.id) {
                    this.setValue()
                }
            }
        },
        methods: {
            setValue() {
                this.info = JSON.parse(JSON.stringify(this.Item))
                if(this.info.contractor_supervisor_by) {
                    this.info.contractor_supervisor_by = Object.assign(this.info.contractor_supervisor_by, {
                        user_id: this.info.contractor_supervisor_id,
                        user_name: this.info.contractor_supervisor_by.name,
                        user_email: this.info.contractor_supervisor_by.email
                    })
                }

                if(this.info.created_by_user && this.info.created_by_user.roles) {
                    this.options.user_roles = this.info.created_by_user.roles
                }

                if(this.info.location_id) {
                    this.info.equipment = {
                        id: this.info.location_id,
                        equipment_lift_number: this.info.equipment_lift_number,
                        equipment_id: this.info.equipment_id,
                        name: this.info.location,
                        location_id: this.info.location_id,
                        equipment_type: this.info.equipment_type
                    }
                }

                if(this.info.supplier_id && this.info.supplier) {
                    this.info.supplier = {
                        id: this.info.supplier_id,
                        name: this.info.supplier
                    }
                }   

                if(this.info.created_at_manual) {
                    this.info.date = moment(this.info.created_at_manual).toDate()
                    this.info.time = moment(this.info.created_at_manual).format("HH:mm")
                }

                if(this.info.follow_up_actions && this.info.follow_up_actions.length) {
                    for (const value of this.info.follow_up_actions) {
                        if(value.administrative_charge) {
                            value.administrative_charge = this.$accounting.formatMoney(value.administrative_charge)
                        }
                    }
                }

                if(this.info.client_contract_id && (!this.ClientContractID || !this.ClientContractID.id || (this.ClientContractID && this.ClientContractID.id && this.ClientContractID.id != this.info.client_contract_id))) {
                    this.$store.dispatch( 'ContractController/getClientContractID', this.info.client_contract_id).then(response => {
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    })
                }
                this.getCheckListGroupData()
                this.getWorkers()
            },
            setDefaultValue() {
                this.info = Object.assign(this.info, {
                    id: null,
                    project: null,
                    status: null,
                    created_by_user: {
                        id: null,
                        name: null,
                        role_name: null
                    },
                    supplier: null,
                    date: null,
                    time: null,
                    equipment: null,
                    contractor_supervisor_by: null,
                    supporting_documents_file: [],
                    photos: [],
                    supporting_documents: []
                })
                if(this.User && this.User.id) {
                    this.info.created_by_user.id = this.User.id
                    this.info.created_by_user.name = this.User.name
                    this.info.created_by_user.role_name = this.User.roles[0].name
                    this.options.user_roles = this.User.roles
                    if(this.options.user_roles.length) {
                        let role_id = this.options.user_roles[0].id
                        const regex = /safety officer/i;
                        let roles = this.options.user_roles.filter(r => regex.test(r.name.toLowerCase()))
                        if(roles && roles.length && roles[0]) {
                            role_id = roles[0].id
                        }
                        
                        this.info.role_id = role_id
                    }
                }

                this.info.date = moment().toDate()
                this.info.time = moment().format("HH:mm")
            },
            inputValue(item) {
                if(item.input.value) { 
                    item.status = item.status = 'Filled';                     
                } else { 
                    item.status = item.status = 'Unfilled';
                }

                let objClone = JSON.parse(JSON.stringify(item));
                objClone.expand.forEach((item, index) => {
                    if(item.contractor.value && item.contractor.value.id) {
                        item.contractor.value = item.contractor.value.name
                    }
                    
                    if(item.administrative_charge && item.administrative_charge.value) {
                        item.administrative_charge.value = this.$accounting.unformat(item.administrative_charge.value)
                    }
                    console.log(item.administrative_charge)
                })

                let request = {
                    id: objClone.id,
                    value: objClone.input.value,
                    status: objClone.status,
                    expand: objClone.expand
                };

                let checkListEntryData = [request];
                if(this.checkListEntryUpdate.length > 0){
                    checkListEntryData = Object.assign([], this.checkListEntryUpdate);
                }
                let flag = false;
                if(checkListEntryData.length > 0){
                    for (let i = 0; i < checkListEntryData.length; i++) {
                        if (request && request.id == checkListEntryData[i].id) {
                            this.checkListEntryUpdate[i] = request;
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        this.checkListEntryUpdate.push(request);
                    }
                }
                
                this.$emit('inputType', false)
            },
            resetValueSupportingDocument(index) {
                if(this.info.supporting_documents[index] && !this.info.supporting_documents[index].is_checked) {
                    this.info.supporting_documents[index].input_value = this.info.supporting_documents[index].item_no = null
                    if(this.info.supporting_documents[index].doc_type == 'Risk Assessment') {
                        this.info.supporting_documents[index].ra_ref = null
                    }

                    if(this.info.supporting_documents[index].doc_type == 'Inspection Report') {
                        this.info.supporting_documents[index].photo = null
                    }
                }
            },
            resetData() {
                this.attachment.items = this.attachment.files =  [],
                this.attachment.project_file = null
            },
            resetDataChecklist() {
                this.checkListEntryUpdate = [];
            },
            handleFocus(value, item) {
                this.$emit('inputType', true)
            },
            /*-- Get Data --------*/
            async getCheckListGroupData(){
                // this.loadingCheckListEntry = true;
                await this.$store
                    .dispatch("SafetyAppController/getSafetyCheckListGroupData", this.$route.params.id)
                    .then((result) => {
                        this.checklistItems = result.items;
                        // this.loadingCheckListEntry = false;
                    })
                    .catch((err) => {
                        // this.loadingCheckListEntry = false;
                });
            },
            async getChecklistTemplates(){
                this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [
                    1000, 1, {contract_id: this.info.contract.id}
                ])
                .then(response => {
                    this.options.checklist_templates = response.data.data.items;
                })
                .catch(err => {
                    this.options.checklist_templates = [];
                });
            },
            removeProjectFile(img) {
                if (img.moment) {
                    this.info.supporting_documents_file = this.info.supporting_documents_file.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.info.supporting_documents_file = this.info.supporting_documents_file.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("SafetyAppController/deleteAttachments", {
                        ids: [img.id]
                    }).then(() => {
                        this.$emit("reloadItem");
                    })
                }
            },
            deleteFile(img) {
                if (img.moment) {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.moment != img.moment
                    );
                    this.info.photos = this.info.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("SafetyAppController/deleteAttachments", {
                        ids: [img.id]
                    }).then(() => {
                        this.$emit("reloadItem");
                    })
                }
            },

            async dowloadAttachments() {
                let items = this.info.supporting_documents_file;
                if(items && items.length) {
                    for (let index = 0; index < items.length; index++) {
                        const item = items[index];
                        const params = {
                            url: item.url.original,
                            image_file_name: item.image_file_name
                        };

                        await this.$store.dispatch("FileDownloadController/getFile", params)
                    }
                }
            },
            editBacsicInfo() {
                // this.loadUser();
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    completed_by_id: this.Item.completed_by_id,
                    acknowledged_by_id: this.Item.acknowledged_by_id,
                    pm_acknowledged_by_id: this.Item.pm_acknowledged_by_id,
                    submitted_by_id: this.Item.submitted_by_id,
                    submitted_at: this.Item.submitted_at ? new Date(this.Item.submitted_at) : null,
                    submitted_at_hour: this.Item.submitted_at ? moment(new Date(this.Item.submitted_at)).format("HH:mm") : null,
                    acknowledged_at: this.Item.acknowledged_at ? new Date(this.Item.acknowledged_at) : null,
                    acknowledged_at_hour: this.Item.acknowledged_at ? moment(new Date(this.Item.acknowledged_at)).format("HH:mm") : null,
                    pm_acknowledged_at: this.Item.pm_acknowledged_at ? new Date(this.Item.pm_acknowledged_at) : null,
                    pm_acknowledged_at_hour: this.Item.pm_acknowledged_at ? moment(new Date(this.Item.pm_acknowledged_at)).format("HH:mm") : null,
                    completed_at: this.Item.completed_at ? new Date(this.Item.completed_at) : null,
                    completed_at_hour: this.Item.completed_at ? moment(new Date(this.Item.completed_at)).format("HH:mm") : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            loadUser(search = '') {
                let filters = {
                    // user_name:{type:"text",value:search,function:"ilike",with:[]},
                    user_email:{type:"text",value:search,function:"ilike",with:[]},
                    user_type:{type:"text",value:'',function:"ilike",with:[]},
                    role_name:{type:"text",value:'',function:"ilike",with:[]},
                    contract_id:{type:"number",value:this.Item.client_contract_id,function:"=",with:[]}
                };

                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: {},
                    useDatabaseView:true
                };

                let type_user= 'FM Officer'
                if(this.Item.status == 'Submitted') {
                    type_user= 'Supplier'
                    filters.role_name.value = "Contractor Supervisor"
                    filters.contract_id.value = this.Item.project_id
                    request.staff = true
                }

                filters.user_type.value = type_user;
                request.filter = filters;
                
                this.$store.dispatch("UserDutyController/getItems", request)
                    .then(result=>{
                        if(type_user == 'FM Officer') {
                            this.modals.bacsicInfo.options.fm_users = result.items;
                        } else {
                            this.modals.bacsicInfo.options.supllier_users = result.items;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            searchUsers(search, loading) {
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.loadUser(search);
                    loading(false);
                }, 500);
            },
            checkShowPopUpSignature() {
                this.updateBasicInfo();
            },
            updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                let params = this.processJob(this.modals.bacsicInfo.data);
                if(params === false) return

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: this.Item.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "non_conformance_report"));
                        // this.is_open_signature = false;
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'contractor supervisor acknowledged') {
                    status = 'acknowledged';
                    data.acknowledged_by_id = data.pm_acknowledged_by_id
                }
                status = status.replace(" ", "_")
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'acknowledged': {
                        status: 'Contractor Supervisor Acknowledged',
                        acknowledged_by_id: data.acknowledged_by_id || null,
                        acknowledged_at: null,
                    },
                    'pm_acknowledged': {
                        status: 'PM Acknowledged',
                        pm_acknowledged_by_id: data.pm_acknowledged_by_id || null,
                        pm_acknowledged_at: null,
                    },
                    'completed': {
                        status: 'Completed',
                        completed_by_id: data.completed_by_id || null,
                        completed_at: null,
                    },
                };
                

                const obj = defaultStatus[status];

                if(status != 'completed') {
                    if(!obj[`${status}_by_id`]) {
                        this.$alertNotification(`Please select ${obj.status} By`, "danger");
                        return false
                    }
                }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            },
            async getWorkers(search = '') {
                let tableRequest = {
                    filter: { company_id: this.info.supplier ? this.info.supplier.id : null },
                    search: search, 
                    page: 1,
                    limit: -1
                }

                await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                    .then(response => {
                        this.options.workers = response.items;
                    })
                    .catch(err => {})
            },
            async searchWorker(search, loading) {
                loading(true)
                this.options.workers = []
                if (this.timer.workers) {
                    clearTimeout(this.timer.workers);
                    this.timer.workers = null;
                }
                this.timer.workers = setTimeout(async () => {
                    try {
                        await this.getWorkers(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            setDefaultProject(val) {
                if(this.$route.params.id == '0' || this.$route.params.id == 0) {
                    this.info.project = val
                }
                    
            },
            resetContractorSupervisor() {
                this.info.contractor_supervisor_by = null
            },
            resetDataByProject() {
                this.info.equipment = null
                this.info.supplier = null
                this.info.contractor_supervisor_by = null
            },
            handleAddExpand(expand, isManual) {
                let supplier = { id: "", name: "" }
                if(!isManual && this.info.supplier) {
                    supplier = {
                        id: this.info.supplier.id,
                        name: this.info.supplier.name
                    }
                }

                if(!expand) return;
                let obj = {
                    administrative_charge: {
                        name: "Administrative Charge",
                        type: "Amounts",
                        value: ""
                    },
                    contractor: {
                        name: "Contractor User Name",
                        type: "Worker",
                        value: "",
                        worker_id: isManual ? null : 0,
                    },
                    id_wp: {
                        name: "ID\/WP#",
                        type: "IDWP",
                        value: ""
                    },
                    company: {
                        name: "Contractor Company",
                        type: "Company",
                        value: supplier.name,
                        company_id: supplier.id
                    }
                }

                expand.push(obj);
                console.log(expand)
            },
            handleDeleteExpand(it, idx) {
                it.expand.splice(idx, 1);
                this.inputValue(it)
            },
            hanldeInputWorker(val, idx_ex, it) {
                if(val) {
                    it.expand[idx_ex].contractor.worker_id = val.id
                    it.expand[idx_ex].id_wp.value = val.ic_fin
                } else {
                    it.expand[idx_ex].contractor.worker_id = 0
                    it.expand[idx_ex].id_wp.value = null
                }

                this.inputValue(it)
            }
        }
    }
</script>
<style lang="scss">
    .custom-checkbox-safety {
        margin-left: 1rem;
        .custom-control-label {
            padding-left: 1rem;
        }
    }
    .photosThumb {
        &.photosThumb-safety {
            .list-thumb {
                li {
                    width: 150px;
                    height: 150px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    span {
                        &.delete {
                            top: 0;
                            right: 10px;
                            img {
                                width: 15px;
                                height: 15px;
                            }
                        }
                    }
                }
            }
        }
    }
    .tooltip {
        max-width: 400px;
    }
</style>